import {useDevice} from '@lookiero/aurora';

export const usePlatform = (): 'WEB' | 'APP' => {
  const {platform} = useDevice();

  return platform.web ? 'WEB' : 'APP';
};
